import React from 'react';
import type PlanTeamsType from '@jira/spa-apps__advanced-roadmaps-plan-teams/src/ExportedComponent.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import type { Props } from '@jira/portfolio-3__portfolio/src/app-simple-plans/view/main/tabs/teams/types.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/**
 * Plan Teams page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanTeams: LazyComponent<React.ComponentType<Props>> = lazyForPaint<
	typeof PlanTeamsType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-teams", jiraSpaEntry: "async-plan-teams" */ '@jira/spa-apps__advanced-roadmaps-plan-teams/src/ExportedComponent.tsx'
			),
		),
	{ ssr: false },
);

const AsyncPlanTeams = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanTeams} pageId="plan-teams" shouldShowSpinner />
);

export default AsyncPlanTeams;
